// Szkielet zakładki „Raporty” strony badania: ten sam układ co Reports.tsx (panel 260px ze statystykami i ośrodkami,
// grupy ośrodków z kartami raportów), szare paski w miejscu danych.
import { LoadingRegion, Skeleton } from "../../components/ui/Skeleton";

const STATS = ["Raporty", "Ośrodki", "W trakcie", "Zaakceptowane"];

const ReportCardSkeleton = () => (
  <div className="bg-[var(--sc-surface)] border border-[var(--sc-border)] rounded-[10px] flex overflow-hidden mb-1.5">
    <div className="w-1 flex-shrink-0 bg-[var(--sc-border)]" />
    <div className="flex-1 flex items-center gap-5 px-[18px] py-[14px]">
      <div className="w-20 flex-shrink-0">
        <Skeleton className="h-4 w-14 mb-1.5" />
        <Skeleton className="h-2.5 w-10" />
      </div>
      <div className="flex-1 flex items-center gap-2">
        <Skeleton className="w-5 h-5 rounded-full" />
        <Skeleton className="h-3 w-40" />
      </div>
      <Skeleton className="h-6 w-24 rounded-[20px]" />
    </div>
  </div>
);

export const StudyReportsSkeleton = () => (
  <LoadingRegion label="Wczytywanie badania" className="flex h-full">
    <aside className="w-[260px] bg-[var(--sc-surface)] border-r border-[var(--sc-border)] flex flex-col flex-shrink-0 overflow-hidden">
      <div className="px-5 py-5 border-b border-[var(--sc-border)]">
        <div className="text-[10px] font-medium uppercase tracking-[0.1em] text-[var(--sc-muted)] mb-3.5">Podsumowanie</div>
        <div className="grid grid-cols-2 gap-2.5">
          {STATS.map((label) => (
            <div key={label} className="bg-[var(--sc-bg)] rounded-[8px] px-3 py-2.5">
              <Skeleton className="h-[22px] w-8" />
              <div className="text-[10px] text-[var(--sc-muted)] mt-1 uppercase tracking-[0.05em]">{label}</div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex-1 overflow-hidden py-4">
        <span className="block text-[10px] font-medium uppercase tracking-[0.1em] text-[var(--sc-muted)] px-5 mb-2">Ośrodek</span>
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="px-5 py-2.5">
            <Skeleton className="h-3 w-36 mb-1.5" />
            <Skeleton className="h-2.5 w-24" />
          </div>
        ))}
      </div>
    </aside>
    <main className="flex-1 overflow-hidden px-8 py-6">
      <div className="flex items-center gap-2.5 mb-5">
        <Skeleton className="h-9 w-[220px] rounded-[8px]" />
        <Skeleton className="h-7 w-20 rounded-full" />
        <Skeleton className="h-7 w-20 rounded-full" />
      </div>
      {[3, 2].map((cards, g) => (
        <div key={g} className="mb-6">
          <div className="mb-2.5 px-0.5 pb-2.5 border-b border-[var(--sc-border)]">
            <Skeleton className="h-3.5 w-52 mb-1.5" />
            <Skeleton className="h-2.5 w-40 mb-2" />
            <Skeleton className="h-4 w-28 rounded-[8px]" />
          </div>
          {Array.from({ length: cards }, (_, i) => (
            <ReportCardSkeleton key={i} />
          ))}
        </div>
      ))}
    </main>
  </LoadingRegion>
);
